import { ChangeDetectionStrategy, Component, effect, inject, input, OnInit, signal } from '@angular/core';
import { ContentLayout5 } from '@components/content/components/content-layout-5/model';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-5',
  imports: [TitleComponent],
  templateUrl: './content-layout-5.component.html',
  styleUrl: './content-layout-5.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout5Component implements OnInit {
  readonly data = input.required<ContentLayout5>();
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  private breakpoints = inject(ResponsiveService).breakpoints;

  constructor() {
    effect(() => {
      if (this.breakpoints()) {
        this.subtitle.set({
          level: 'SPAN',
          type: 'SLASH',
          font: 'INTER',
          color: this.breakpoints() === 'mobile' ? 'GREY_LIGHT' : 'BLACK',
          text: this.data().subtitle,
          weight: 500,
          align: {
            mobile: 'LEFT',
            desktop: 'LEFT',
          },
          size: {
            mobile: 'SPAN',
            desktop: 'SPAN',
          },
        });
      }
    });
  }

  ngOnInit(): void {
    this.title.set({
      level: 'H2',
      text: this.data().title,
      color: 'BLACK',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'H2',
        desktop: 'H3',
      },
    });
  }
}
